import { IBookingTime } from 'shared-types/index';

export interface ITimeSelector extends IProps, IHandlers, IServices {}

interface passThroughProps {
  preselectedTimeIndex?: number; // only used if isCustomTime = false
  preselectedTime?: Date; // only used if isCustomTime = true
  times?: IBookingTime[]; // only used if isCustomTime = false
  useReversedColors?: boolean; // assumes the component is sitting on a dark colour, so all text, borders, etc are white
  isCustomTime?: boolean;
  isLockedBooking?: boolean;
}

/**
 * Properties passed in from angular instantiation.
 * This can include functions/handlers that simply call back to the Angular parent component
 * and do not need to modify app state (via a service).
 */
export interface IContainerProps extends passThroughProps {
  onSelectedChanged: (index: number, time: string) => void;
}

/**
 * Properties passed directly into the react component. If the container is responsible for fetching async data, via a
 * service, these may differ from IContainerProps.
 */
export interface IProps extends passThroughProps {}

/**
 * Handlers used to modify app state (via a service) from within the module's container.
 * Similar to redux mapDispatchToProps.
 */
export interface IHandlers {
  handleSelectedChanged: (index: number, time: string) => void;
}

export interface IServices {}

export const classPrefix = 'TimeSelector';
